/**
 * Content widths are page roles, not module preferences.
 *
 * A focused create form stays readable, an entity detail has room for its
 * related cards and previews, and a table-heavy workflow can spend more of a
 * desktop viewport. Keeping the choices here prevents clients, cohorts,
 * students, and HR users from inventing different widths for the same job.
 */
export const OPERATOR_FORM_PAGE = 'max-w-2xl mx-auto'
export const OPERATOR_DETAIL_PAGE = 'max-w-4xl mx-auto'
export const OPERATOR_WORKFLOW_PAGE = 'max-w-6xl mx-auto'

/**
 * The Admin shell's 56px header is above page content in normal flow.
 * Non-list pages therefore fill the remaining viewport, not another full
 * viewport; otherwise even a short form produces a phantom scrollbar.
 * ListPage owns the same geometry independently because it also coordinates
 * sticky toolbars and pagination.
 */
export const OPERATOR_PAGE_MAIN =
  'min-h-[calc(100svh-3.5rem)] bg-surface-app p-8'
